import { useState, useContext, useEffect, useRef } from 'react';
import UserContext from "../../contexts/userContext";
import ErrorContext from '../../contexts/errorContext';

import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { ChatPromptTemplates } from './2-1_ChatPromptTemplates';
import { ChatContext } from './2-2_ChatContext';

import "../../styles/ChatInput.css" 
import { isAdmin } from '../../utils';

export const ChatInput = () => {
    const { userContext, addMessage } = useContext(UserContext);
    const { setErrorContext } = useContext(ErrorContext);

    const [ hasHumanInput, setHasHumanInput ] = useState(false);
    
    const [ showChatPromptTemplates, setShowChatPromptTemplates ] = useState(false);

    const [ showChatContext, setShowChatContext ] = useState(false);
    const [ chatContext, setChatContext ] = useState('');
    const hasQueryContext = chatContext.length > 0;

    const humanInputRef = useRef(null);
    const handleKeyDown = (event) => {
        const humanInputTextarea = humanInputRef.current;
        if (event.target !== humanInputTextarea) {
            return;
        }

        let humanInput = humanInputTextarea.value;
        const hasHumanInputNow = humanInput.length > 0;
        if (hasHumanInput !== hasHumanInputNow) {
            setHasHumanInput(hasHumanInputNow);
        }

        const doSubmitQuery = event.key === 'Enter' && !event.ctrlKey && !event.shiftKey;

        if (doSubmitQuery) {
            humanInput = humanInput.trim();
            humanInputTextarea.value = humanInput;
            
            // it seems that submitQuery either uses userContext at the time the event listener was added
            // submitQuery(humanInput);

            // simulating a mouse click on the submit button as a workaround
            document.getElementById('submitQueryButton').click();
        } else {
            if (event.key === 'Enter' && !event.shiftKey) {
                const selectionStart = event.target.selectionStart;
                const selectionEnd = event.target.selectionEnd;
                humanInput = humanInput.substring(0, selectionStart) + '\n' + humanInput.substring(selectionEnd);
                humanInputTextarea.value = humanInput;
                humanInputTextarea.selectionStart = selectionStart+1;
                humanInputTextarea.selectionEnd = selectionStart+1;
            }
            
            try {
                humanInputTextarea.setAttribute('style', `height:0px;overflow-y:hidden;`);
                const scrollHeight = humanInputTextarea.scrollHeight;
                const maxHeight = Math.round(window.innerHeight * .25);
                const newHeight = Math.min(scrollHeight, maxHeight);
                humanInputTextarea.setAttribute('style', `height:${newHeight}px;overflow-y:hidden;`)
            } catch (e) {}
        }
    };
    
    useEffect(() => {
        console.log('adding human input listener')
        humanInputRef.current.addEventListener('keydown', handleKeyDown);
        
        return () => {
            if (humanInputRef?.current) {
                console.log('removing human input listener');
                humanInputRef.current.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, []);

    const submitQuery = () => {
        const humanInputTextarea = document.getElementById('humanInputTextarea');
        const humanInput = humanInputTextarea.value;
        if (humanInput.length === 0) {
            setErrorContext({
                title: 'Missing Input',
                body: 'Provide a question or command'
            });
            return;
        }

        humanInputTextarea.disabled = true;
        document.getElementById('submitQueryButton').disabled = true;

        const promptTemplate = JSON.stringify({
            withContext: userContext.templates.chat.withContext.filter(x => x.isActive)[0],
            withoutContext: userContext.templates.chat.withoutContext.filter(x => x.isActive)[0]
        });
        
        addMessage([{
            type: 'human',
            content: humanInput,
            humanInput: humanInput,
            context: chatContext,
            promptTemplate: promptTemplate,
            isCommand: false,
            created: new Date().toISOString().slice(0,-1)
        },{
            type: 'ai',
            content: 'STREAMING_PLACEHOLDER',
            humanInput: humanInput,
            context: chatContext,
            promptTemplate: promptTemplate,
            isCommand: false,
            created: new Date().toISOString().slice(0,-1),
            setHasHumanInput: setHasHumanInput
        }]);

        setChatContext('');
    }

    return(
        <>
            <Card className="user-input-card">
                <InputGroup>
                    {isAdmin(userContext.account.username) && <Button 
                        id="promptTemplateButton"
                        title="Select prompt template"
                        className="a8-light-gray-background"
                        onClick={() => setShowChatPromptTemplates(true)}
                    >
                        <i className="bi-question-square text-muted" />
                    </Button>}
                    <Button 
                        id="queryContextButton"
                        title="Add context"
                        onClick={() => setShowChatContext(true)}
                        className="a8-light-gray-background"
                        style={{"borderLeft": "1px solid rgba(0, 0, 0, 0.12)", "borderRight": "1px solid rgba(0, 0, 0, 0.12)"}}
                    >
                        {hasQueryContext ? (
                            <i className="bi-puzzle-fill a8-blue" />
                        ) : (
                            <i className="bi-puzzle text-muted" />
                        )}
                    </Button>
                    
                    <Form.Control
                        ref={humanInputRef}
                        id="humanInputTextarea"
                        as="textarea"
                        placeholder="Enter question or command"
                        rows={1}
                        //onChange={(changeEvent) => handleHumanInput(changeEvent)}
                    />
                    
                    <Button
                        id="submitQueryButton"
                        onClick={submitQuery}
                        title="Submit query"
                        className="a8-light-gray-background"
                        style={{"borderLeft": "1px solid rgba(0, 0, 0, 0.12)"}}
                    >
                        {hasHumanInput ? (
                            <i className="bi-arrow-up-square-fill a8-blue" />
                        ) : (
                            <i className="bi-arrow-up-square text-muted" />
                        )}
                    </Button>
                </InputGroup>
            </Card>

            <ChatPromptTemplates 
                show={showChatPromptTemplates}
                setShow={setShowChatPromptTemplates}
            />

            <ChatContext 
                show={showChatContext}
                setShow={setShowChatContext}
                chatContext={chatContext}
                setChatContext={setChatContext}
                conversationid={userContext?.conversation?.conversationid}
            />

        </>
    )
}

